<template>
  <div>
    <ministry-breadcrumbs :mainTitle="mainTitle" :breadcrumbs="breadcrumbs" />

    <!-- Table Container Card -->
    <b-card class="mb-0">
      <!-- Table Top -->
      <b-tabs>
        <b-tab
          lazy
          @click="$router.push({ name: 'ngo-users-management' })"
          v-if="canNavigate('ministry_ngo_users_rp')"
          title="مستخدمي المنظمات"
        >
          <transition name="fade" duration="400" mode="out-in">
            <router-view key="/ministry/settings/users/ngo-users" />
          </transition>
        </b-tab>

        <b-tab
          lazy
          @click="$router.push({ name: 'ministry-users-management' })"
          v-if="canNavigate('ministry_users_rp')"
          title="مستخدمي الوزارة"
        >
          <transition name="fade" duration="400" mode="out-in">
            <router-view key="/ministry/settings/users/ministry-users " />
          </transition>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import { BCard, BTabs, BTab, BRow, BCol, BButton } from "bootstrap-vue";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import userStoreModule from "./store";
import MinistryBreadcrumbs from "@/modules/ministry/components/MinistryBreadcrumbs.vue";
import AuthHelpers from "@/utils/auth-helpers";

export default {
  components: {
    BCard,
    BTabs,
    BTab,
    BRow,
    BCol,
    BButton,
    MinistryBreadcrumbs,
  },

  setup() {
    const USER_APP_STORE_MODULE_NAME = "Ministry/Settings/Users";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    return {
      mainTitle: "المستخدمين",
      breadcrumbs: [
        {
          text: "الإعدادات",
          to: "/ministry/settings",
        },
        {
          text: "المستخدمين",
          active: true,
        },
      ],
    };
  },
  data() {
    return {
      nameOfTab : -1
    };
  },
  methods: {
    canNavigate(item) {
      return AuthHelpers.canNavigate(item);
    },
  },
  // watch: {
  //   nameOfTab(val) {
  //     console.log("this.$route.path" , this.$route.name)
  //     console.log("this.$route.path !== '/ministry/settings/users/ngo-users')" , this.$route.path !== '/ministry/settings/users/ngo-users')
  //     // if(val === 0 && this.$route.name === 'settings-users') this.$router.push({ name: 'ngo-users-management' })
  //     // if(val === 1  && this.$route.name === 'settings-users') this.$router.push({ name: 'ministry-users-management' })
      
  //     console.log("nameOfTab" , val)
  //   },
  // },
};
</script>
